export function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function toNonEmptyString(value: any): string | null {
  if (value == null) {
    return null;
  }

  const stringValue = typeof value === 'string' ? value : `${value}`;
  const trimmed = stringValue.trim();
  return trimmed || null;
}
